import './modal_filter_view.js.coffee'

Namespace 'Common.Sessions.Filters.SingleFilters'

class Common.Sessions.Filters.SingleFilters.MultipleValuesFilterView extends Common.Sessions.Filters.SingleFilters.ModalFilterView
  template: JST['backbone/templates/common/dashboard/filters/single_filters/multiple_values_filter']

  events:
    _.extend({}, Common.Sessions.Filters.SingleFilters.ModalFilterView.prototype.events,
      'click .select-all': '_selectAll'
      'click .unselect-all': '_unselectAll'
    )

  initialize: ({values, placeholder, title, subtitle, selectedOptions, editable}) ->
    super({editable, values, placeholder, title, selectedOptions})
    @subtitle = subtitle
    @selector = @_selector(values, @selectedOptions)
    throw new Error('The selector must be an instance of App.SelectView') unless @selector instanceof App.SelectView

    @listenTo(@selector, 'change', @_onSelectorChange)

  render: ->
    super()
    @$el.addClass('multiple-values-filter')
    @$el.find('.modal-body').html @template
      translations:
        selectAll: I18n.t('customer_visual_mode.filters.multiple_values_filter.select_all')
        unselectAll: I18n.t('customer_visual_mode.filters.multiple_values_filter.unselect_all')
        subtitle: @subtitle
    @$el.find('.toggle-all-container').hide() if not @editable
    @$el.find('.selector').append(@selector.el)
    @_onSelectorChange()
    @

  _selectAll: =>
    @selector.selectAll()

  _unselectAll: =>
    @selector.clean()

  _onSelectorChange: =>
    valuesAreSelected = @selector.toArray().length > 0
    @$el.find('.toggle-all-container').toggleClass('values-are-selected', valuesAreSelected)
    @_setDisableSelectContainer({disabled: !valuesAreSelected})
    @_setDisableAcceptButton({disabled: !valuesAreSelected})

  _setDisableSelectContainer: ({disabled}) ->
    @_selectContainer().toggleClass('disabled', disabled)

  _unselectAllButton: ->
    @$el.find('.unselect-all')

  _selectContainer: ->
    @$el.find('.selector')

  _selector: (values) ->
    throw new Error('NotImplementedError: select of type App.SelectView was not provided')

  getSelectedValues: ->
    @selector.toArray()
